import _ from 'underscore';
const {Backbone} = require('backboneAdapter');
import ExpandTypeModel from 'js/models/expand.type.model';

    export default Backbone.Collection.extend({
        model: ExpandTypeModel,
        url: "/CampaignCloud/CreditsController/ExpansionTypes"

    });
